import Home from './Home.data-manager-bundle-wl.vue'

export default {
  Home
}